import React, { useState } from "react";
import { Upload, Typography, Form } from "antd";
import { CameraOutlined } from "@ant-design/icons";

const { Text } = Typography;

const ThumbnailUploader = ({ name, label, required = false, onChange }) => {
  const [previewImage, setPreviewImage] = useState(null);

  const handleBeforeUpload = (file) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => setPreviewImage(reader.result);

    // Call the onChange handler to sync with the Form
    if (onChange) {
      onChange(file);
    }

    // Prevent automatic upload
    return false;
  };

  return (
    <Form.Item
      name={name}
      label={label}
      valuePropName="file"
      rules={
        required
          ? [
              {
                required: true,
                message: `${label} is required`,
              },
            ]
          : []
      }
    >
      <Upload
        listType="picture-card"
        beforeUpload={handleBeforeUpload}
        showUploadList={false}
      >
        <div
          style={{
            width: "400px",
            height: "100px",
            border: "1px dashed #d9d9d9",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            background: "#f5f5f5",
            overflow: "hidden", // Ensures the image does not overflow
            position: "relative",
          }}
        >
          {previewImage ? (
            <img
              src={previewImage}
              alt="thumbnail"
              style={{
                height: "50%",
                objectFit: "cover",
              }}
            />
          ) : (
            <>
              <CameraOutlined style={{ fontSize: "32px", color: "#999" }} />
              <Text
                style={{
                  position: "absolute",
                  bottom: "20px",
                  fontSize: "14px",
                }}
              >
                {/* {label} <br /> */}
                {/* <span style={{ fontSize: "12px" }}>(400 x 250)</span> */}
              </Text>
            </>
          )}
        </div>
      </Upload>
    </Form.Item>
  );
};

export default ThumbnailUploader;
